import { useState, useEffect } from "react";
import { Checkbox, Col, Form, Input, InputNumber, Row, Select } from "antd";
import "../users/addUser.css";

import { useForm } from "antd/lib/form/Form";
import { submitUserThunk } from "../../../store/thunks/usersThunk";
import AddEditForm from "../../../components/molecules/Forms/addEditForm";
import { useDispatch } from "react-redux";
import secureLocalStorage from "react-secure-storage";

const { Option } = Select;

const AddUser = ({
  editData,
  clients,
  roles,
  reportingSupervisors,
  allManagers,
  allAtls,
  statuses,
  onSuccess,
  children,
}) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const [selectedRole, setSelectedRole] = useState();
  const [profilePicInfo, setProfilePicInfo] = useState("");
  const [errors, setErrors] = useState([]);
  const [profilePicWithUrlChecked, setProfilePicWithUrlChecked] =
    useState(false);
  const [existingImage, setExistingImage] = useState(null);
  const [showFileInput, setShowFileInput] = useState(true);

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setProfilePicWithUrlChecked(checked);

    if (checked) {
      setProfilePicInfo(null);
      setShowFileInput(false);

      form.setFieldValue("profilePicUrl", "");
    }
  };

  const inputComponent = <Input className="w-100" />;

  const onSubmit = async (values, editData) => {
    const isEdit = Boolean(editData);
    const headers = {
      "Content-Type": "multipart/form-data", // Make sure to set the content type
    };
    const getBase64ImageExtension = (urlOrBase64) => {
      // Check if the input is a Base64 string
      if (urlOrBase64.startsWith("data:image")) {
        // Extract the MIME type from the Base64 string
        const mimeTypeMatch = urlOrBase64.match(
          /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/,
        );
        if (mimeTypeMatch && mimeTypeMatch[1]) {
          // Extract the file extension from the MIME type
          const extension = mimeTypeMatch[1].split("/")[1];
          return extension;
        } else {
          // Default to empty string if no extension found
          return "";
        }
      } else {
        // Extract the file extension from the URL
        const ext = urlOrBase64.split(".").pop().split("?")[0];
        return ext;
      }
    };

    const normalizeId = (val) =>
      typeof val === "string" && val.length === 24 ? val : null;

    const payload = {
      empID: parseInt(values?.empID),
      name: values?.name,
      imageName:
        parseInt(values?.empID) + "_" + values?.name?.replaceAll(" ", "_"),
      email: values?.email,
      urole: values?.urole,
      profilePicUrl:
        profilePicWithUrlChecked === true
          ? values?.profilePicUrl
          : profilePicInfo
            ? profilePicInfo
            : null,
      client: normalizeId(values.client),
      reportingSupervisor: normalizeId(values.reportingSupervisor),
      atl: normalizeId(values.atl),
      status: isEdit ? values.status : "ACTIVE",
      uploadType: profilePicWithUrlChecked === true ? "thumbUrl" : "other",
      ext:
        profilePicWithUrlChecked === true
          ? getBase64ImageExtension(values?.profilePicUrl)
          : profilePicInfo
            ? getBase64ImageExtension(profilePicInfo)
            : "", //values?.profilePicUrl?.split(".").pop()
      //headers,
      historySource: "backend",
      historyAction: isEdit ? "update" : "create",
      historyUserID: slsLIUId,
    };

    if (isEdit) {
      payload.id = editData.key;
    }

    await dispatch(submitUserThunk(payload)).unwrap();
  };

  const getId = (val) => {
    if (!val) return null;
    if (typeof val === "string" && val.length === 24) return val; // ObjectId
    if (typeof val === "object") return val._id;
    return null;
  };

  useEffect(() => {
    if (!editData) return;

    const roleValue =
      editData.role?._id || editData.role || editData.role?.[0]?._id || null;

    form.setFieldsValue({
      empID: editData.empID,
      name: editData.name,
      email: editData.email,
      urole: roleValue,
      client: getId(editData.client),
      reportingSupervisor: getId(editData.reportingSupervisor),
      atl: getId(editData.atl),
      client: getId(editData.client),
      reportingSupervisor: getId(editData.reportingSupervisor),
      atl: getId(editData.atl),
      status: editData.status,
    });
    setSelectedRole(roleValue);

    if (editData.profilePicUrl) {
      setExistingImage(editData.profilePicUrl);
      setShowFileInput(false);
    }
  }, [editData]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // Read image parameters
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        // Check for SVG file type
        const isSVG = file.type === "image/svg+xml";
        img.src && setProfilePicInfo(img.src);
      };
    };

    reader.readAsDataURL(file);
  };
  return (
    <AddEditForm
      form={form}
      editData={editData}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      successMessages={{
        create: "User created successfully",
        update: "User updated successfully",
      }}
      fields={
        <>
          <Row className="pb-16" gutter={[12, 12]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="m-0"
                label="Employee ID"
                name="empID"
                rules={[
                  { required: true, message: "Please enter employee id!" },
                ]}
                validateStatus={errors && errors["empID"] ? "error" : undefined}
                help={errors && errors["empID"] ? errors["empID"] : undefined}
              >
                <InputNumber
                  placeholder="Enter employee id"
                  className="w-100"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="m-0"
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please enter the name!" }]}
              >
                <Input placeholder="Enter name" className="w-100" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="m-0"
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
                validateStatus={errors && errors["email"] ? "error" : undefined}
                help={errors && errors["email"] ? errors["email"] : undefined}
              >
                <Input placeholder="Enter email" className="w-100" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="m-0"
                label="Role"
                name="urole"
                rules={[{ required: true, message: "Please select a role!" }]}
              >
                <Select
                  showSearch
                  allowClear
                  options={roles}
                  className=""
                  onChange={(val) => {
                    setSelectedRole(val);
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      ?.toLowerCase()
                      .includes(input?.toLowerCase())
                  }
                  placeholder="Select Role"
                ></Select>
              </Form.Item>
            </Col>

            {(selectedRole === "agent" || selectedRole === "atl") && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  className="m-0"
                  label="Supervisor"
                  name="reportingSupervisor"
                  rules={[
                    {
                      required: true,
                      message: "Please select a supervisor!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    options={reportingSupervisors}
                    className=""
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        ?.toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                    placeholder="Select Supervisor"
                  ></Select>
                </Form.Item>
              </Col>
            )}

            {selectedRole === "tl" && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <Form.Item
                  className="m-0"
                  label="Supervisor"
                  name="reportingSupervisor"
                  rules={[
                    {
                      required: true,
                      message: "Please select a supervisor!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    options={allManagers}
                    className=""
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        ?.toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                    placeholder="Select Supervisor"
                  ></Select>
                </Form.Item>
              </Col>
            )}

            {selectedRole === "agent" && (
              <>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <Form.Item
                    className="m-0"
                    label="Assistant Team Leader"
                    name="atl"
                  >
                    <Select
                      showSearch
                      allowClear
                      options={allAtls}
                      className=""
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          ?.toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      placeholder="Select ATL"
                    ></Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label="Client"
                    name="client"
                    rules={[
                      { required: true, message: "Please select a client!" },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      options={clients}
                      className=""
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          ?.toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      placeholder="Select Client"
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            <Col xs={24} sm={24} md={24} lg={24}>
              <Form.Item label="Profile Image" name="profilePicUrl">
                {profilePicWithUrlChecked === true ? (
                  inputComponent
                ) : existingImage && !showFileInput ? (
                  <div style={{ position: "relative", width: 150 }}>
                    <img
                      src={`${process.env.REACT_APP_BACKEND}/images/${existingImage}`}
                      alt="profile"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: 6,
                        border: "1px solid #ddd",
                      }}
                    />

                    {/*  Remove button */}
                    <span
                      onClick={() => {
                        setExistingImage(null);
                        setShowFileInput(true);
                        form.setFieldValue("profilePicUrl", null);
                      }}
                      style={{
                        position: "absolute",
                        top: -8,
                        right: -8,
                        background: "#ff4d4f",
                        color: "#fff",
                        borderRadius: "50%",
                        width: 22,
                        height: 22,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        fontSize: 12,
                      }}
                    >
                      ✕
                    </span>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="upload-list-block"
                  />
                )}
              </Form.Item>
              <Form.Item label="" name="profilePicUrl">
                <Checkbox
                  checked={profilePicWithUrlChecked}
                  onChange={handleCheckboxChange}
                  className="form-label-antd profilePicWithUrlCheckBox"
                  name="profilePicWithUrlCheckBox"
                >
                  Upload with url
                </Checkbox>
              </Form.Item>
              {editData && (
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label="Status"
                    name="status"
                    rules={[
                      { required: true, message: "Please select a status!" },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      options={statuses}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input?.toLowerCase())
                      }
                      placeholder="Select Status"
                    />
                  </Form.Item>
                </Col>
              )}
            </Col>
          </Row>
        </>
      }
    />
  );
};
export default AddUser;
